export const LIVE_PREVIEW_ENABLED =
  process.env.CONTENTSTACK_LIVE_PREVIEW === 'true';

export const REGION = (process.env.CONTENTSTACK_REGION || 'eu').toLowerCase();

export const BRANCH = process.env.CONTENTSTACK_BRANCH || 'main';

const REGIONAL_HOST_PREFIX = REGION && REGION !== 'us' ? `${REGION}-` : '';

export const PREVIEW_API_HOST =
  process.env.CONTENTSTACK_PREVIEW_HOST ||
  `${REGIONAL_HOST_PREFIX}rest-preview.contentstack.com`;

export const DELIVERY_API_URL =
  process.env.CONTENTSTACK_CDN ||
  `https://${REGIONAL_HOST_PREFIX}cdn.contentstack.com/v3`;

export const CONTENTSTACK_APP_HOST =
  process.env.CONTENTSTACK_APP_HOST ||
  `${REGIONAL_HOST_PREFIX}app.contentstack.com`;

export const API_KEY = process.env.CONTENTSTACK_API_KEY as string;
export const DELIVERY_TOKEN = process.env.CONTENTSTACK_DELIVERY_TOKEN as string;
export const PREVIEW_TOKEN = process.env.CONTENTSTACK_PREVIEW_TOKEN as string;
export const ENVIRONMENT = process.env.CONTENTSTACK_ENVIRONMENT as string;

export const QUERIED_FIELD_NAMES: Record<string, string> = JSON.parse(
  process.env.CONTENTSTACK_LIVE_PREVIEW_FIELD_NAMES || '{}'
);

export const CONTENT_TYPE_POSTFIX =
  process.env.CONTENTSTACK_CONTENT_TYPE_POSTFIX || '';
